// extracted by mini-css-extract-plugin
module.exports = {"labelWrapper":"+MNMkfb8hHCQ+crJQ7OdKw==","medium":"_5VRWbwTv7tIV53n4BbUqDQ==","large":"pPq2jfHKrIPVdwWpBqouhw==","extraSmall":"q3jVx3KacHyh7MjD+ru2pg=="};